export default __webpack_public_path__ + "622a0b95a65997b603c4b4094c6cc1f2.png";